<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="row">
                    <div class="col-md-12">
                    <!-- Debut Filtres -->
                        <div class="d-flex justify-content-center float-right">
                            <form class="row g-1" @submit.prevent="getTransactions">                     
                                <div class="col-md-4">
                                    <label for="dateBegin" class="form-label">Début</label>
                                    <input type="date" v-model="dateBegin" class="form-control" id="dateBegin" required>
                                </div>
                                <div class="col-md-4">
                                    <label for="dateEnd" class="form-label">Fin</label>
                                    <input type="date" v-model="dateEnd" class="form-control" id="dateEnd" required>
                                </div>
                                <div class="col-md-4 align-self-end">
                                    <button type="submit" @click="getTransactions" class="btn btn-primary">Rechercher</button>
                                </div>
                            </form>
                        </div>
                    <!-- Fin Filtre -->
                </div>
                </div>
                        <div class="card-body">
                            <h3>Transactions <span class="badge bgbadge">{{transactions.length}}</span> </h3>
                            <div class="table-responsive mb-5">
                                <template v-if="transactions.length>0">  
                                    <table class="table table-striped table-bordered display text-center mb-5">
                                        <thead>
                                            <tr>
                                                <th>No Transaction</th>
                                                <th>Patient</th>
                                                <th>No Facture</th>
                                                <th>Montant</th>
                                                <th>Type Transaction</th>
                                                <th>Méthode</th>
                                                <th>Status Transaction</th>
                                                <th>Référence</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                <tr v-for="(transaction,key) in transactions" :key="key">
                                                    <td>{{transaction.id_transaction}}</td>
                                                    <td>{{transaction.patient}}</td>
                                                    <td><router-link :to="{ name: 'payment', params: { facture: transaction.number } }" title="Voir">{{transaction.facture_number}}</router-link></td>
                                                    <td>{{transaction.montant}} {{ transaction.indice }}</td>
                                                    <td>{{ transaction.type_transaction }}</td>
                                                    <td>{{transaction.methode}}</td>
                                                    <td>{{transaction.status_transaction==1?'Pending':'Cancel'}}</td>
                                                    <td>{{transaction.reference}}</td>
                                                    <td :title="transaction.date_transaction">{{ formatDate(transaction.date_transaction) }}</td>
                                                </tr>                                
                                        </tbody>
                                    </table>
                                </template>
                                <template v-if="transactions.length==0">
                                    <div class="modal-preloader">
                                        <div class="">Aucune donnée!!</div>
                                    </div>
                                </template>
                                <!-- <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"Transactions",
    components:{
        DashView
    },
    data(){
        const getFormattedDate = (timeZone) => {
      const newDate = new Date();
      const options = { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' };
      const formattedDate = newDate.toLocaleDateString('en-US', options);
      const [month, day, year] = formattedDate.split('/');
      return `${year}-${month}-${day}`;
    };
      return{
          transactions:[],
          dateBegin:getFormattedDate('America/Port-au-Prince'),
          dateEnd:getFormattedDate('America/Port-au-Prince'),
          info_groupe:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
      }
    },
    created(){
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        // const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
        axios.get(`${base_url}/all_ctransaction`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  console.log(response.data.Transactions);
                  if(response.data.Transactions){
                      this.transactions = response.data.Transactions;
                  }                
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
    },
    methods:{
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${day}-${month}-${year}`;
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        },
        getTransactions(){
              console.log(this.dateBegin,this.dateEnd);
              this.transactions=[];
              if(this.dateBegin && this.dateEnd){
                  axios.get(`${base_url}/all_ctransaction?datedebut=${this.dateBegin}&&datefin=${this.dateEnd}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                  .then((response)=>{
                      console.log(response.data);
                      if(response.data.Transactions){
                            this.transactions = response.data.Transactions;
                        }   
                  })
                  .catch((error)=>{
                      console.log('Une erreur est survenue!');
                      console.error(error);
                  })
              }
        }

    }
}
</script>
<style lang="">
    
</style>